export default "__VITE_ASSET__BKvAojvK__"